import { type BoxProps, Flex, Text } from '@mantine/core'

import { useDocumentState } from '../../../booking-documents/hooks/useDocumentState'
import { SectionTable } from './SectionTable'

type SectionSignatureProps = BoxProps

export function SectionSignature({ ...props }: SectionSignatureProps) {
  const { documentPreview, translate } = useDocumentState()

  const firstPartySignatureField = `{{${translate?.('signature')}; name=FirstPartySignature; role=FirstParty; type=signature; required=true; width=220; height=50}}`
  const firstPartyFullName = `{{${translate?.('full_name')}; name=FullName; role=FirstParty; type=text; required=true; readonly=false; width=115; height=30}}`
  const firstPartyDateField = `{{${translate?.('date')}; name=AppointmentDate; role=FirstParty; type=date; required=true; readonly=false; width=60; height=30}}`

  return (
    documentPreview?.booking_settings
      ?.documents_contract_include_signatures && (
      <SectionTable {...props}>
        <SectionTable.Header>
          <Text fw={500} size='md'>
            {translate?.('label_customer_signature')}
          </Text>
        </SectionTable.Header>
        <SectionTable.Body>
          <Flex mt={24} align='center' justify='space-between' gap='xl'>
            <Text c='white' size='8px' mr='lg' w={130} mih={30}>
              {firstPartyFullName}
            </Text>

            <Flex align='center' ml='2rem' justify='center' w={60} h={30}>
              <Text size='md' mr='sm'>
                {translate?.('date')}:
              </Text>
              <Text c='white' mt='md' size='8px'>
                {firstPartyDateField}
              </Text>
            </Flex>

            <Text
              c='white'
              size='8px'
              w={240}
              h={50}
              mt='sm'
              ml='md'
              style={{ borderBottom: '1px solid var(--mantine-color-gray-7)' }}
            >
              {firstPartySignatureField}
            </Text>
          </Flex>
        </SectionTable.Body>
      </SectionTable>
    )
  )
}
